"use client";

import { usePathname } from "next/navigation";
import { useIntl } from "react-intl";

import { TypoTextBold } from "ui/Typo";

export default function CurrentStep() {
    const { formatMessage } = useIntl();
    const pathname = usePathname();
    const isSecondStep = pathname?.includes("second-step");

    return (
        <TypoTextBold color="text-font-3">
            {formatMessage({ id: "currentStep" }, { current: isSecondStep ? 2 : 1, total: 2 })}
        </TypoTextBold>
    );
}
